import { useMemo } from 'react'
import { useQueryResponse } from '../core/QueryResponseProvider'
import { useQueryRequest } from '../core/QueryRequestProvider'
import { useListFilters } from '../core/ListFiltersProvider'
import { atendimentosMedicosColumns } from './columns/_columns'
import { AtendimentoList, AtendimentoView } from '../../../atendimento/core/_models'
import { getAtendimentoById } from '../../../atendimento/core/_requests'
import { CustomTable, TableEmptyState } from '../../../../../components'
import { useT } from '_metronic/i18n/Metronici18n'
import { AtendimentoExpandedRow } from './columns/AtendimentoExpandedRow'

export const AtendimentoMedicoTable = () => {
  const { isLoading, isError, refetch, response } = useQueryResponse()
  const { hasFilters, clearFilters } = useListFilters()
  const { t } = useT()

  const columns = useMemo(() => atendimentosMedicosColumns(t), [t])

  const emptyState = hasFilters ? (
    <TableEmptyState
      title='Nenhum atendimento encontrado'
      description='Revise os filtros aplicados ou troque de aba.'
      action={{ label: 'Limpar filtros', onClick: clearFilters }}
    />
  ) : (
    <TableEmptyState
      title='Nenhum atendimento nesta aba'
      description='Os atendimentos aparecem aqui conforme mudam de estado.'
    />
  )

  return (
    <CustomTable<AtendimentoList>
      id='kt_table_atendimento_medico'
      ariaLabel='Atendimentos'
      itemLabel={{ singular: 'atendimento', plural: 'atendimentos' }}
      data={response?.data || []}
      columns={columns}
      isLoading={isLoading}
      isError={isError}
      onRetry={refetch}
      emptyState={emptyState}
      queryHooks={{ useQueryRequest, useQueryResponse }}
      enableExpand
      onExpandFetch={(row) => getAtendimentoById(Number(row.original.id))}
      getExpandLabel={(row) => row.paciente?.pessoa?.nome || row.protocolo || 'atendimento'}
      renderExpand={(data: AtendimentoView, loading) => (
        <AtendimentoExpandedRow isLoading={loading} data={data} />
      )}
    />
  )
}
